import "./ProviderListingCard_module.css";
import { useEffect, useCallback, useState, useMemo } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import Years_Of_Experience from "../../assets/images/icon/Vector.png";
import Events_performed from "../../assets/images/icon/star.png";
import Ratings_Reviews from "../../assets/images/icon/Vector.png";
import user_avatar from "../../assets/images/icon/User Avatar 1.png";
import veglog from "../../assets/images/icon/veg.png";
import {
  addToCart,
  removeFromCart,
  removeTenthouseByEventId,
  isProviderAdded,
  checkisProviderAdded,
  getCartId,
  selectCartData,
  triggerRefresh,
  removePreistByEventId,
  getTenthouseProviderID,
  isServiceCheckedOut,
  getCateringItemsByEventId,
} from "../../store/cartSlice";
import {
  getPriestToCartAPI,
  addPriestToCartAPI,
  deletePriestFromCartAPI,
  addTentToCartAPI,
  deleteTentCartItemAPI,
  addCateringToCartAPI,
  deleteCateringCartItemAPI,
  addPriestPackageToCartAPI,
} from "../../Apiservices/Auth/cart/Addtocart_api";

import AddToCartButton from "./addtocartbutton";
import React from "react";
import LoadMap from "../EventServices/LoadMap";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import PhoneAndroidOutlinedIcon from "@mui/icons-material/PhoneAndroidOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import "primeflex/primeflex.css";
import debuglog from "../../util/helperutil";
import { useNavigate } from "react-router-dom";
import { removePriestByCartId } from "../../store/cartbodydataslice";
import { usePriestCart } from "../../hooks/usePriestCart";
import { useTentCart } from "../../hooks/useTentCart";
import { useCateringCart } from "../../hooks/usecateringcart";
import PackageOverlay from "./PackageOverlay";
import MenuDialog from "../MenuDialog";

function ProviderListingCard({
  quantity,
  serviceId,
  services,
  providerid,
  event,
  key,
  latitude,
  longitude,
  name,
  address,
  distance,
  mobile,
  email,
  packages,
  price: originalPrice,
  discount: originalDiscount,
  validUpto: originalvalidUpto,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const eventID = event.id || NaN;
  const service_id = event.eventId || NaN;
  const eventname = event.eventTitle || NaN;
  const { priestCartLoading, refreshPriestCart, removePriestCartItem } =
    usePriestCart();
  const { tentCartLoading, refreshTentCart, removeTentProvider, editbutton } =
    useTentCart();
  const { refreshCateringCart, removeCateringProvider } = useCateringCart();

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);

  const [showPackageInfo, setShowPackageInfo] = useState(false);
  console.log("checpackage", services);

  const alreadyAdded = useSelector((state) =>
    serviceId == 9
      ? isProviderAdded(
          state,
          eventID,
          providerid,
          serviceId,
          services.itemId
        )
      : isProviderAdded(state, eventID, providerid, serviceId)
  );
  const isChecked = useSelector((state) =>
    serviceId == 9
      ? isServiceCheckedOut(
          state,
          eventID,
          providerid,
          parseInt(serviceId),
          services.itemId
        )
      : isServiceCheckedOut(state, eventID, parseInt(serviceId))
  );

  const Itemnames_withquantity = useMemo(() => {
    if (Number(serviceId) !== 8) return null;
    if (!Array.isArray(quantity) || !Array.isArray(services)) return [];
    return quantity
      .map((q) => {
        const match = services.find((s) => s.serviceId === q.id);
        if (!match) return null;
        return { itemName: match.serviceName, quantity: q.count };
      })
      .filter(Boolean);
  }, [serviceId, quantity, services]);

  const { main: catering_main, sides: catering_sides } = useMemo(() => {
    if (Number(serviceId) !== 9) {
      return { main: [], sides: [] };
    }
    return {
      main: services?.includedItems || [],
      sides: [],
    };
  }, [serviceId, services?.includedItems]);

  const includedItemsInfo = useMemo(() => {
    if (Number(serviceId) !== 9) return null;
    const items = services?.includedItems ?? null;
    return formatIncludedItems(items, { maxVisible: 6 });
  }, [serviceId, services]);

  const [addnewcaterer, setaddnewcaterer] = useState(false);
  const checkalreadyAdded = useSelector((state) =>
    serviceId === 9
      ? checkisProviderAdded(
          state,
          eventID,
          providerid,
          serviceId,
          services.itemId
        )
      : checkisProviderAdded(state, eventID, providerid, serviceId)
  );

  const cartId = useSelector((state) => getCartId(state, eventID, serviceId));

  const addedproviderID = useSelector((state) =>
    getTenthouseProviderID(state, eventID)
  );

  const calculateTotalPrices = (quantityList, services) => {
    const currentDate = new Date();
    return services.reduce(
      (acc, item) => {
        const regular = parseFloat(item.price);
        const discount = parseFloat(item.discountPrice);
        const validUpto = new Date(item.discountValidUpto);
        const match = quantityList.find((q) => q.id === item.serviceId);
        const itemQuantity = match ? match.count : 0;
        acc.totalPrice += isNaN(regular) ? 0 : regular * itemQuantity;
        if (!isNaN(discount) && discount > 0 && currentDate < validUpto) {
          acc.totalDiscountPrice += discount * itemQuantity;
          acc.validDates.push(validUpto);
        } else {
          acc.totalDiscountPrice += regular * itemQuantity;
        }
        return acc;
      },
      {
        totalPrice: 0,
        totalDiscountPrice: 0,
        validDates: [],
      }
    );
  };

  let price = originalPrice;
  let discount = originalDiscount;
  let validUpto = originalvalidUpto;

  const handleSeeMore = useCallback((menuType, items) => {
    console.log("Opening dialog with items:", items?.length);
    setSelectedMenu({
      label: menuType,
      items: items,
    });
    setIsDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    console.log("Closing dialog");
    setIsDialogOpen(false);
    setSelectedMenu(null);
  }, []);

  if (serviceId == 8) {
    const { totalDiscountPrice, totalPrice, validDates } = calculateTotalPrices(
      quantity,
      services
    );
    price = totalPrice ?? originalPrice;
    discount = totalDiscountPrice ?? originalDiscount;
    validUpto = validDates.length > 0 ? validDates[0] : originalvalidUpto;
  }

  const getValuesFromDate = (services) => {
    const currentDate = new Date();
    const result = {
      totalPrice: 0,
      totalDiscountPrice: 0,
      validDates: [],
    };
    if (!services || services.length === 0) {
      return result;
    }
    const item = services;
    const regular = parseFloat(item.regularPrice);
    const discount = parseFloat(item.discountedPrice);
    const validUpto = new Date(item.discountValidUpto);
    const isRegularValid = !isNaN(regular);
    const isDiscountValid =
      !isNaN(discount) && discount > 0 && currentDate < validUpto;
    if (isRegularValid) {
      result.totalPrice = regular;
      if (isDiscountValid) {
        result.totalDiscountPrice = discount;
        result.validDates.push(validUpto);
      } else {
        result.totalDiscountPrice = regular;
      }
    }
    return result;
  };

  const [selectedServiceId, setSelectedServiceId] = useState(null);
  if (serviceId == 9) {
    const { totalPrice, totalDiscountPrice, validDates } =
      getValuesFromDate(services);
    price = totalPrice ?? originalPrice;
    discount = totalDiscountPrice ?? originalDiscount;
    validUpto = validDates.length > 0 ? validDates : originalvalidUpto;
  }

  const handleAddPackageToCart = async (packageSelection) => {
    console.log("Adding package to cart:", packageSelection);
    const { packageId, packageData } = packageSelection;
    if (checkalreadyAdded && !isChecked) {
      setAlertMessage(true);
      setPackageToAdd(packageSelection);
      return;
    } else if (isChecked) {
      setpaidcheckdialog(true);
      return;
    }
    await addPackageToCart(packageId, packageData);
  };

  const [packagePriceInfo, setPackagePriceInfo] = useState({
    hasPackages: false,
    availableForCurrentEvent: false,
    selectedPackagePrice: null,
    selectedPackageDiscountPrice: null,
    selectedPackageValidTill: null,
  });

  useEffect(() => {
    if (Number(serviceId) !== 7) return;
    console.log("checpackage", packages);
    const hasPackages = packages && Array.isArray(packages) && packages.length > 0;
    let availableForCurrentEvent = false;
    let relevantPackages = [];
    if (hasPackages) {
      relevantPackages = packages.filter((pkg) => {
        if (
          !pkg.recommendedEvents ||
          !Array.isArray(pkg.recommendedEvents) ||
          pkg.recommendedEvents.length === 0
        ) {
          return true;
        }
        return pkg.recommendedEvents.some((event) => {
          const eventIdMatch = event.eventId === eventID;
          const eventTitleMatch =
            event.eventTitle?.toLowerCase() === eventname?.toLowerCase();
          const eventNameMatch =
            event.eventName?.toLowerCase() === eventname?.toLowerCase();
          return eventIdMatch || eventTitleMatch || eventNameMatch;
        });
      });
      availableForCurrentEvent = relevantPackages.length > 0;
      console.log("Filtered packages for event:", relevantPackages);
      console.log("Available for current event:", availableForCurrentEvent);
    }
    setPackagePriceInfo({
      hasPackages,
      availableForCurrentEvent,
      relevantPackagesCount: relevantPackages.length,
    });
  }, [packages, eventID, eventname, serviceId]);

  let displayPrice = price;
  let displayDiscount = discount;
  let displayValidUpto = validUpto;

  if (Number(serviceId) === 7) {
    if (packagePriceInfo.selectedPackageDiscountPrice) {
      displayPrice = packagePriceInfo.selectedPackagePrice;
      displayDiscount = packagePriceInfo.selectedPackageDiscountPrice;
      displayValidUpto = packagePriceInfo.selectedPackageValidTill;
    }
  }

  const isPackageForEvent = (pkg) => {
    if (
      !pkg.recommendedEvents ||
      !Array.isArray(pkg.recommendedEvents) ||
      pkg.recommendedEvents.length === 0
    ) {
      return true;
    }
    return pkg.recommendedEvents.some((event) => {
      const eventIdMatch = event.eventId === eventID;
      const eventTitleMatch =
        event.eventTitle?.toLowerCase() === eventname?.toLowerCase();
      const eventNameMatch =
        event.eventName?.toLowerCase() === eventname?.toLowerCase();
      return eventIdMatch || eventTitleMatch || eventNameMatch;
    });
  };

  const cartStatepreist = useSelector(
    (state) => state.cart.serviceList.preist[eventID]
  );
  const cartStatecatering = useSelector(
    (state) => state.cart.serviceList.catering[eventID]
  );
  const cartStatetenthouse = useSelector(
    (state) => state.cart.serviceList.tenthouse[eventID]
  );

  useEffect(() => {}, [cartStatepreist, cartStatecatering, cartStatetenthouse]);

  const generateTentCartItems = () => {
    if (!Array.isArray(services) || !Array.isArray(quantity)) return [];
    return services
      .map((service) => {
        const match = quantity.find((q) => q.id === service.serviceId);
        if (match) {
          return {
            tent_house_service_id: service.serviceId,
            mapping_id: service.mappingId,
            quantity: match.count,
          };
        }
        return null;
      })
      .filter((item) => item !== null);
  };

  const [message, setMessage] = useState({ text: "", type: "" });
  const cateringItems = useSelector((state) =>
    getCateringItemsByEventId(state, eventID)
  );

  const handleClick = async () => {
    if (serviceId == 7) {
      try {
        if (checkalreadyAdded) {
          try {
            dispatch(removePreistByEventId({ eventID }));
            removePriestCartItem(cartId, eventID);
            setMessage({
              text: "Existing priest removed. Adding new priest...",
              type: "info",
            });
            const response = await addPriestToCartAPI({
              event_id: eventID,
              priest_id: providerid,
              service_id,
            });
            dispatch(
              addToCart({
                serviceType: "preist",
                eventID,
                providerID: providerid,
                cart_id: cartId,
              })
            );
            console.log("Response from addPriestToCartAPI:", response);
            setMessage({
              text: "Priest successfully replaced in cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error replacing priest:", error);
            setMessage({ text: "Failed to replace priest", type: "error" });
          }
        } else {
          try {
            const response = await addPriestToCartAPI({
              event_id: eventID,
              priest_id: providerid,
              service_id,
            });
            dispatch(
              addToCart({
                serviceType: "preist",
                eventID,
                providerID: providerid,
                cart_id: cartId,
              })
            );
            console.log("Response from addPriestToCartAPI:", response);
            setMessage({
              text: "Priest successfully added to cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error adding priest:", error);
            setMessage({ text: "Failed to add priest", type: "error" });
          }
        }
      } catch (error) {
        console.error("Failed to call addPriestToCartAPI:", error.message);
      }
    }
    if (serviceId == 8) {
      try {
        if (checkalreadyAdded) {
          try {
            removeTentProvider(eventID, addedproviderID);
            dispatch(removeTenthouseByEventId({ eventID }));
            setMessage({
              text: "Existing tenthouse provider removed. Adding new tenthouse...",
              type: "info",
            });
            const tentItems = generateTentCartItems();
            const response = await addTentToCartAPI({
              event_id: eventID,
              tent_provider_id: providerid,
              items: tentItems,
            });
            dispatch(
              addToCart({
                serviceType: "tenthouse",
                eventID: eventID,
                providerID: providerid,
              })
            );
            console.log("Response from addTentToCartAPI:", response);
            setMessage({
              text: "Tenthouse service successfully replaced in cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error replacing tenthouse provider:", error);
            setMessage({
              text: "Failed to replace tenthouse provider",
              type: "error",
            });
          }
        } else {
          const tentItems = generateTentCartItems();
          const response = await addTentToCartAPI({
            event_id: eventID,
            tent_provider_id: providerid,
            items: tentItems,
          });
          console.log("testing eventid", eventID);
          dispatch(
            addToCart({
              serviceType: "tenthouse",
              eventID: eventID,
              providerID: providerid,
            })
          );
          console.log("Response from addTentToCartAPI:", response);
          setMessage({
            text: "Tenthouse service successfully added to cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        }
      } catch (error) {
        console.error("Error adding tenthouse provider:", error);
        setMessage({ text: "Failed to add tenthouse service", type: "error" });
      }
    }

    if (serviceId == 9) {
      if (addnewcaterer) {
        try {
          console.log("got");
          cateringItems.forEach((item) => {
            removeCateringProvider(eventID, item.providerID, item.mapping_id);
            refreshCateringCart();
            dispatch(
              removeFromCart({
                serviceType: "catering",
                eventID,
                providerID: item.providerID,
                mapping_id: item.mapping_id,
              })
            );
          });
          setMessage({
            text: "Catering service successfully removed from cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        } catch (error) {
        }
      } else {
        try {
          const items = [
            { mapping_id: services.itemId, number_of_people: quantity ? quantity : 10 },
          ];
          const response = await addCateringToCartAPI({
            event_id: eventID,
            provider_id: providerid,
            items: items,
          });
          const cartdata = {
            serviceType: "catering",
            eventID: eventID,
            providerID: providerid,
            mapping_id: services.itemId,
          };
          dispatch(addToCart(cartdata));
          setMessage({
            text: "Catering service successfully added to cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        } catch (error) {
          console.log("error for adding catering to cart", error);
          setMessage({
            text: `Failed to ${alreadyAdded ? "remove" : "add"} service: ${
              error.message || "Unknown error"
            }`,
            type: "error",
          });
        }
      }
    }
    navigate("/cart");
    window.scrollTo({ top: 0 });
  };

  const handleRemove = async () => {
    if (serviceId == 7) {
      if (alreadyAdded) {
        try {
          console.log(cartId);
          await deletePriestFromCartAPI(cartId);
          dispatch(removePreistByEventId({ eventID }));
          setMessage({
            text: "Priest successfully removed from cart",
            type: "success",
          });
          dispatch(triggerRefresh());
          console.log("Removed priest from cart successfully");
        } catch (error) {
          console.error(
            "Failed to remove priest from cart:",
            error.message,
            cartId,
            eventID
          );
        }
      }
    }
    if (serviceId == 8) {
      if (alreadyAdded) {
        try {
          await deleteTentCartItemAPI(eventID, providerid);
          dispatch(removeTenthouseByEventId({ eventID: eventID }));
          setMessage({
            text: "Tenthouse service successfully removed from cart",
            type: "success",
          });
          dispatch(triggerRefresh());
        } catch (error) {
          console.log("error while removing from cart", error);
        }
      }
    }
    if (serviceId == 9) {
      try {
        removeCateringProvider(eventID, providerid, services.itemId);
        refreshCateringCart();
        dispatch(
          removeFromCart({
            serviceType: "catering",
            eventID,
            providerID: providerid,
            mapping_id: services.itemId,
          })
        );
        setMessage({
          text: "Catering service successfully removed from cart",
          type: "success",
        });
        dispatch(triggerRefresh());
      } catch (error) {
        console.log("error while deleting in cart", error);
      }
    }
  };

  const handleMainClick = async () => {
    if ((serviceId == 7 || serviceId == 8) && checkalreadyAdded) {
      if (isChecked) {
        setpaidcheckdialog(true);
      } else {
        setAlertMessage(true);
      }
    } else if (serviceId == 9) {
      if (isChecked) {
        setpaidcheckdialog(true);
      } else {
        if (checkalreadyAdded) {
          console.log("start1 checkalreadyAdded", checkalreadyAdded);
          handleClick();
        } else {
          const providerExists = cateringItems.some(
            (item) => item.providerID === providerid
          );
          console.log("got to check allItemsInCart", cateringItems);
          if (providerExists || cateringItems.length == 0) {
            handleClick();
          } else if (!providerExists) {
            setAlertMessage(true);
          }
        }
      }
    } else {
      handleClick();
    }
  };

  const ServiceButton = ({ serviceId, alreadyAdded, handleRemove, handleMainClick }) => {
    if (serviceId === "7") {
      return alreadyAdded ? (
        <AddToCartButton
          label="Remove"
          icon="pi pi-trash"
          className="remove_button_forcart"
          onClick={handleRemove}
        />
      ) : (
        <AddToCartButton label="Add to Cart" onClick={handleMainClick} />
      );
    }
    if (serviceId === "8" || serviceId === "9") {
      return alreadyAdded ? (
        <AddToCartButton
          label="Remove"
          icon="pi pi-trash"
          className="remove_button_forcart"
          onClick={handleRemove}
        />
      ) : (
        <AddToCartButton label="Add to Cart" onClick={handleMainClick} />
      );
    }
    return null;
  };

  const [SeeMoredialog, setSeeMoredialog] = useState(false);
  const handleseemore_button = () => {
    if (Number(serviceId) == 9) setSeeMoredialog(true);
  };

  const addPackageToCart = async (packageId, packageData) => {
    try {
      const response = await addPriestPackageToCartAPI({
        event_id: eventID,
        priest_id: providerid,
        service_id,
        package_id: packageId,
      });
      console.log("Added priest with package:", response);
      dispatch(
        addToCart({
          serviceType: "preist",
          eventID,
          providerID: providerid,
          service_id,
          package_id: packageId,
          price: packageData.price,
          discountprice: packageData.offeredPrice,
          discountvalidupto: packageData.validTill,
          quantity: 1,
          is_checked_out: false,
        })
      );
      setMessage({
        text: "Package added to cart",
        type: "success",
      });
      dispatch(triggerRefresh());
      navigate("/cart");
    } catch (error) {
      console.error("Error adding package to cart:", error);
      setMessage({
        text: "Failed to add package to cart",
        type: "error",
      });
    }
  };

  const [alertMessage, setAlertMessage] = useState(false);
  const [paidcheckdialog, setpaidcheckdialog] = useState(false);
  const [packageToAdd, setPackageToAdd] = useState(null);

  const handleOk = async () => {
    if (serviceId == 7) {
      if (packageToAdd) {
        await addPackageToCart(packageToAdd.packageId, packageToAdd.packageData);
        setPackageToAdd(null);
      } else {
        await handleClick();
      }
      setAlertMessage(false);
    }
    if (serviceId == 8) {
      await handleClick();
      setAlertMessage(false);
    }
    if (serviceId == 9) {
      if (checkalreadyAdded) {
        await handleClick();
        setAlertMessage(false);
      } else {
        if (cateringItems && cateringItems.length > 0) {
          try {
            console.log("Removing existing catering items...");
            cateringItems.forEach((item) => {
              removeCateringProvider(eventID, item.providerID, item.mapping_id);
              refreshCateringCart();
              dispatch(
                removeFromCart({
                  serviceType: "catering",
                  eventID,
                  providerID: item.providerID,
                  mapping_id: item.mapping_id,
                })
              );
            });
            setMessage({
              text: "Catering service successfully removed from cart",
              type: "success",
            });
            dispatch(triggerRefresh());
          } catch (error) {
            console.error("Error removing catering items:", error);
          }
        }
        await handleClick();
        setAlertMessage(false);
      }
    }
    setAlertMessage(false);
  };

  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const handleCancel = () => {
    setAlertMessage(false);
  };

  const footer = (
    <div>
      <Button
        label="Cancel"
        icon="pi pi-times"
        className="p-button-text"
        onClick={handleCancel}
      />
      <Button label="OK" icon="pi pi-check" autoFocus onClick={handleOk} />
    </div>
  );

  const paidfooter = (
    <div>
      <div>
        <Button
          label="Cancel"
          icon="pi pi-times"
          className="p-button-text"
          onClick={() => setpaidcheckdialog(false)}
        />
        <Button
          label="Myorders"
          icon="pi pi-check"
          autoFocus
          onClick={() => navigate(`/myorder?eventId=${eventID}`)}
        />
      </div>
    </div>
  );

  return (
    <>
      <Dialog
        header="Confirmation"
        visible={alertMessage}
        style={{ width: "30vw" }}
        footer={footer}
        onHide={() => setAlertMessage(false)}
        closable={false}
      >
        {alertMessage && (
          <>
            {Number(serviceId) === 7 && (
              <p>
                You need to remove the existing priest. Do you want to remove?
              </p>
            )}
            {Number(serviceId) === 8 && (
              <p>
                You need to remove the existing tent provider. Do you want to
                remove?
              </p>
            )}
            {Number(serviceId) == 9 && (
              <p>
                You need to remove the existing catering provider. Do you want to
                remove from cart?
              </p>
            )}
          </>
        )}
      </Dialog>
      <Dialog
        header="Alert"
        visible={paidcheckdialog}
        style={{ width: "30vw" }}
        onHide={() => setpaidcheckdialog(false)}
        closable={false}
        footer={paidfooter}
      >
        <>
          {Number(serviceId) === 7 && (
            <p>
              You have already Paid for priest for this event you can only have one priest
            </p>
          )}
          {Number(serviceId) === 8 && (
            <p>
              You have already Paid for tentprovider for this event you can only have one tentprovider
            </p>
          )}
          {Number(serviceId) === 9 && (
            <p>
              You have already Paid for catering Provider for this event you can only have one catering provider
            </p>
          )}
        </>
      </Dialog>

      {
        <div className="card-container-services">
          {message.text && (
            <div className={`alert alert-${message.type}`}>{message.text}</div>
          )}

          <div key={key} className="event-service-data w-full">
            <div className="top-container">
              <div style={{ display: "flex", gap: "20px" }}>
                <div className="event-service-headder">
                  <div className="event-service-headtop">
                    <h3>{name || ""}</h3>
                  </div>
                  <div style={{ gap: "4px" }}>
                    {address?.length > 0 && (
                      <div className="info-item">
                        <LocationOnOutlinedIcon className="service-icon" />
                        {address.length > 30
                          ? `${address.substring(0, 30)}***`
                          : address}
                      </div>
                    )}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      {!isNaN(distance) && (
                        <div className="info-item">
                          <RouteOutlinedIcon className="service-icon" />
                          {typeof distance === "number"
                            ? `${(distance / 10000).toFixed(2)} km`
                            : ""}
                        </div>
                      )}{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div className="service-container">
                <div className="service-data">
                  {Number(serviceId) == 9 && <span className="Total-Amount">
                    ₹{discount ?? price} / Plate
                  </span>}
                  <div className="rating-container">
                    <span className="Rating-Text">
                      {""}
                      <img
                        style={{
                          verticalAlign: "middle",
                          marginRight: "6px",
                          width: "15px",
                          height: "15px",
                        }}
                        src={Events_performed}
                        alt="Events performed"
                      />{" "}
                      <span className="data-info">4.5</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {serviceId == 9 && (
              <div className="catering-courses">
                <div className="coutse-items">
                  <div className="course-header">Items</div>
                  <div className="course-items-by-list">
                    {catering_main.length > 0 ? (
                      <>
                        {catering_main.slice(0, 4).map((item, key) => (
                          <div key={key} className="menu-item-row">
                            <span className="menu-item-name">
                              {item.itemName}
                            </span>
                            <span className="menu-item-quantity">
                              ({item.qty})
                            </span>
                          </div>
                        ))}
                        {catering_main.length > 4 && (
                          <div style={{ textAlign: "left", width: "100%" }}>
                            <a
                              href="#"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleSeeMore("Main", catering_main);
                              }}
                              className="see-more-link"
                            >
                              View More Items ({catering_main.length - 4} more)
                            </a>
                          </div>
                        )}
                      </>
                    ) : (
                      <div style={{ textAlign: "left" }}>
                        No items available
                      </div>
                    )}
                  </div>
                </div>

                {/* Dialog Component - Rendered outside the conditional flow but controlled by state */}
                <MenuDialog
                  isOpen={isDialogOpen}
                  onClose={handleCloseDialog}
                  label={selectedMenu?.label || "Main Items"}
                  mainItems={selectedMenu?.items || []}
                />
              </div>
            )}

            {Number(serviceId) == 8 && (
              <div className="catering-courses">
                <div className="coutse-items">
                  <div className="course-header">Items</div>
                  <div className="course-items-by-list">
                    {Itemnames_withquantity?.map((item, idx) => (
                      <div key={idx}>
                        {item.itemName} ({item.quantity})
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="final-price-list">
              {Number(serviceId) == 9 ? (
                <div className="price-details">
                  <div className="add-to-cart">
                    <ServiceButton
                      serviceId={serviceId}
                      alreadyAdded={alreadyAdded}
                      handleRemove={handleRemove}
                      handleMainClick={handleMainClick}
                    />
                  </div>
                </div>
              ) : Number(serviceId) == 8 ? (
                <div className="price-details">
                  <div style={{ display: "flex", fontWeight: "600", gap: "6px" }}>
                    <span>Total Amount ₹{discount ?? price}</span>
                    {discount && (
                      <span
                        style={{ marginLeft: "0px", fontWeight: "400" }}
                        className={discount ? "line-through" : ""}
                      >
                        ₹{price}
                      </span>
                    )}
                  </div>
                  <div className="add-to-cart">
                    <ServiceButton
                      serviceId={serviceId}
                      alreadyAdded={alreadyAdded}
                      handleRemove={handleRemove}
                      handleMainClick={handleMainClick}
                    />
                  </div>
                </div>
              ) : (
                <>
                  {Number(serviceId) === 7 && (
                    <div className="price-details">
                      {packagePriceInfo.hasPackages && (
                        <div className="package-indicator">
                          <span className="package-badge">
                            <i
                              className="pi pi-box"
                              style={{ marginRight: "4px" }}
                            ></i>
                            {packagePriceInfo.availableForCurrentEvent
                              ? `Packages Available (${packagePriceInfo.relevantPackagesCount})`
                              : "Packages (Not for this event)"}
                          </span>
                        </div>
                      )}

                      <div className="price-display-section">
                        {price && discount && validUpto && new Date(validUpto) > new Date() ? (
                          <>
                            <span
                              style={{ marginLeft: "0px", fontWeight: "400" }}
                              className="line-through"
                            >
                              <span>Discounted Price</span> ₹ {price}
                            </span>
                            <span style={{ fontWeight: "700" }}>
                              Price ₹{discount}
                            </span>
                          </>
                        ) : price ? (
                          <span style={{ fontWeight: "700" }}>Price ₹{price}</span>
                        ) : (
                          <div className="no-regular-price">
                            <span
                              style={{ fontStyle: "italic", color: "#666" }}
                            >
                              <i
                                className="pi pi-exclamation-circle"
                                style={{ marginRight: "4px" }}
                              ></i>
                              No individual event price available
                            </span>
                            {packagePriceInfo.hasPackages ? (
                              <small
                                className="text-muted"
                                style={{
                                  display: "block",
                                  marginTop: "4px",
                                }}
                              >
                                Only packages available for this priest
                              </small>
                            ) : (
                              <small
                                className="text-muted"
                                style={{
                                  display: "block",
                                  marginTop: "4px",
                                }}
                              >
                                Contact priest for pricing details
                              </small>
                            )}
                          </div>
                        )}

                        {packagePriceInfo.hasPackages &&
                          packagePriceInfo.availableForCurrentEvent && (
                            <div style={{ marginTop: price ? "8px" : "12px" }}>
                              <PackageOverlay
                                packages={packages}
                                eventName={eventname}
                                eventID={eventID}
                                providerName={name}
                                providerid={providerid}
                                onAddPackageToCart={handleAddPackageToCart}
                                alreadyAdded={alreadyAdded}
                              />
                            </div>
                          )}
                      </div>

                      {price && (
                        <div className="add-to-cart" style={{ marginTop: "12px" }}>
                          <ServiceButton
                            serviceId={serviceId}
                            alreadyAdded={alreadyAdded}
                            handleRemove={handleRemove}
                            handleMainClick={handleMainClick}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default ProviderListingCard;

function formatIncludedItems(raw, opts = {}) {
  const { maxVisible = 6 } = opts;
  if (!Array.isArray(raw) || raw.length === 0) return null;
  const qtyMap = new Map();
  for (const it of raw) {
    const name = (it?.itemName ?? "").toString().trim();
    if (!name) continue;
    const qNum = Number(it?.qty);
    const hasValidQty = Number.isFinite(qNum) && qNum > 0;
    if (!qtyMap.has(name)) {
      qtyMap.set(name, { qtySum: hasValidQty ? qNum : null });
    } else {
      const entry = qtyMap.get(name);
      if (hasValidQty) {
        entry.qtySum = (entry.qtySum ?? 0) + qNum;
      }
    }
  }
  if (qtyMap.size === 0) return null;
  const allTokens = Array.from(qtyMap.entries()).map(([name, { qtySum }]) =>
    qtySum && qtySum > 0 ? `${name} (${qtySum})` : name
  );
  const visible = allTokens.slice(0, maxVisible);
  const hiddenCount = Math.max(allTokens.length - visible.length, 0);
  const join = (arr) => {
    if (typeof Intl !== "undefined" && Intl.ListFormat) {
      return new Intl.ListFormat("en-IN", {
        style: "long",
        type: "conjunction",
      }).format(arr);
    }
    return arr.join(", ");
  };
  const text =
    hiddenCount > 0 ? `${join(visible)} +${hiddenCount} more` : join(visible);
  const fullText = join(allTokens);
  return { text, fullText, visible, hiddenCount };
}

function splitIncludedItems(raw = []) {
  if (!Array.isArray(raw) || raw.length === 0) {
    return { main: [], sides: [] };
  }
  const main = [];
  const sides = [];
  for (const it of raw) {
    const name = (it?.item_name ?? "").toString().trim();
    if (!name) continue;
    const qNum = Number(it?.qty);
    const hasValidQty = Number.isFinite(qNum) && qNum > 0;
    if (hasValidQty) {
      main.push({ name, qty: qNum });
    } else {
      sides.push({ name });
    }
  }
  return { main, sides };
}